import { createAsyncThunk } from '@reduxjs/toolkit';

import { authSet } from '../../utils/request';
import { METHOD_PATCH } from '../../constants/api';

const patchUserData = createAsyncThunk('users/patchUserData',
  async ({ userId, ...formData } = {}, { rejectWithValue }) => {
    try {
      await authSet(METHOD_PATCH, `/users/${userId}`, formData);
      return true;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  });

export default patchUserData;
